import { Component, Input } from '@angular/core';
import { IInitializePasswordRequest } from '../../../../classes/initialize-password';
import { ICodeService } from '../../../../services/icode.service';
import { AppSettings } from '../../../../app.settings';

@Component({
	selector: 'restore-validation',
	template: require('./restore-validation.component.html'),
})
export class RestoreValidationComponent {
	@Input() initRequest: IInitializePasswordRequest;
	@Input() isNewUser: boolean;
	@Input() isOnboardingFlow: boolean;
	@Input() isNewChangePasswordModals: boolean;
	@Input() isEmailUnlockUser: boolean = false;
	public isRebrading = AppSettings.isRebrading;
}
